const pickMeta = (route) =>
    (route.meta || []).find(m => m && (m.auth || (m.roles && m.roles.length))) || {}

export default function ({ app, route, error }) {
    const meta = pickMeta(route)
    const needRoles = meta.roles || []

    if (needRoles.length) {
        const isRoleOk = needRoles.some(r => app.$auth.hasScope(r))

        if (!isRoleOk) return error({ statusCode: 404 })
    }
}